import { FleetIncidentScreen } from "@src/features/patriot-tools";

export default FleetIncidentScreen;
